export const removeTooltipText = 'Delete this organisation';
export const viewTooltipText = 'View profile';
export const addTooltipText = 'Add a new organisation';
export const searchTooltipText = 'Search by organisation name';
export const profilePath = `organisation-profile`;
